module.exports = {"pathContext":{"name":"ProviderPunchInput","kind":"INPUT_OBJECT","type":"OBJECT","fields":[{"defaultValue":null,"description":null,"name":"clockIn","type":{"kind":"SCALAR","name":"DateTime","ofType":null}},{"defaultValue":null,"description":null,"name":"clockOut","type":{"kind":"SCALAR","name":"DateTime","ofType":null}},{"defaultValue":null,"description":null,"name":"providerId","type":{"kind":"SCALAR","name":"ID","ofType":null}}],"description":null,"enumValues":null,"possibleTypes":null}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/input-object-provider-punch-input.json
// module id = 1532
// module chunks = 263736687359637